import styled from 'styled-components';
import { DialogContent } from '@material-ui/core';

export const StyledDialogContent = styled(DialogContent)`
    && {
        padding: ${({ theme }) => theme.spacing * 6}px;
        @media screen and (max-width: 690px) {
            width: auto;
        }
    }
`;

export const DialogTitle = styled.h1`
    margin: 0 0 ${({ theme }) => theme.spacing * 4}px;
    font-size: 24px;
    line-height: 36px;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
`;

export const DialogDescription = styled.p`
    margin: 0 0 ${({ theme }) => theme.spacing * 4}px;
    color: ${({ theme }) => theme.colors.blue};
    line-height: 24px;
`;

export const Label = styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 24px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
`;

export const SaveButton = styled.button`
    height: 44px;
    width: 220px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 6px;
    border: none;
    outline: none;
    cursor: pointer;
`;

export const CloseButton = styled(SaveButton)`
    width: auto;
    margin-right: ${({ theme }) => theme.spacing * 6}px;
    color: ${({ theme }) => theme.colors.gray};
    background-color: unset;
    @media screen and (max-width: 690px) {
        margin: 0;
    }
`;

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: ${({ theme }) => theme.spacing * 10}px;
    @media screen and (max-width: 690px) {
        flex-direction: column-reverse;
        align-items: center;
    }
`;
